export default __webpack_public_path__ + "static/media/ImageAll.781358fa.jpeg";